import { Flex, Box } from '@chakra-ui/react';
import { SearchFilter } from '@/components/ats/filters/components/SearchFilter';
import { useKFlags } from '@/hooks/use-k-flags';
import { DownloadData } from './DownloadData';

export const DrilldownFilter = ({
  dispatch,
  config,
  searchTerm,
  drilldownData,
  reportData,
  initialLoading,
  columnSettingsSlotRef,
}) => {
  const showSearchFilter = drilldownData?.length > 0 || searchTerm;
  const { reportsV2 } = useKFlags();

  return (
    <>
      <Flex
        justifyContent="end"
        p="10px 24px"
        borderTopWidth="1px"
        borderColor="border-color"
        gap="6px"
        alignItems="center"
      >
        {showSearchFilter && (
          <SearchFilter
            isCustomSearch={true}
            onCustomSearch={(searchTermValue) => {
              if (searchTermValue !== searchTerm) {
                dispatch(config.searchAction({ searchTerm: searchTermValue }));
              }
            }}
            searchTerm={searchTerm || ''}
            inputStyles={{
              bg: 'white',
            }}
          />
        )}

        {((reportsV2 && !initialLoading) || searchTerm) && (
          <DownloadData
            reportData={reportData}
            drilldownData={drilldownData}
            isDisabled={!showSearchFilter || initialLoading}
          />
        )}

        {columnSettingsSlotRef && (
          <Box ref={columnSettingsSlotRef} flexShrink={0} />
        )}
      </Flex>
    </>
  );
};
